var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoginDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 117,
  fill: "#F45C3A",
  viewBox: "0 0 125 117"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 5.5,
  r: 4.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 4.5,
  r: 4.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 4.5,
  r: 4.5
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 4.5,
  r: 4.5
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 40.5,
  r: 4.5
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 39.5,
  r: 4.5
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 39.5,
  r: 4.5
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 39.5,
  r: 4.5
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 22.5,
  r: 4.5
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 22.5,
  r: 4.5
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 21.5,
  r: 4.5
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 93.5,
  cy: 21.5,
  r: 4.5
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 21.5,
  r: 4.5
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 5.5,
  r: 4.5
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 4.5,
  r: 4.5
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 4.5,
  r: 4.5
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 4.5,
  r: 4.5
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 40.5,
  r: 4.5
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 39.5,
  r: 4.5
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 39.5,
  r: 4.5
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 39.5,
  r: 4.5
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 22.5,
  r: 4.5
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 22.5,
  r: 4.5
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 21.5,
  r: 4.5
})), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  cx: 93.5,
  cy: 21.5,
  r: 4.5
})), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 21.5,
  r: 4.5
})), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 76.5,
  r: 4.5
})), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 75.5,
  r: 4.5
})), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 75.5,
  r: 4.5
})), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 75.5,
  r: 4.5
})), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 58.5,
  r: 4.5
})), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 58.5,
  r: 4.5
})), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 57.5,
  r: 4.5
})), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
  cx: 93.5,
  cy: 57.5,
  r: 4.5
})), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 57.5,
  r: 4.5
})), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 112.5,
  r: 4.5
})), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 111.5,
  r: 4.5
})), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.5,
  cy: 111.5,
  r: 4.5
})), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 111.5,
  r: 4.5
})), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 94.5,
  r: 4.5
})), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 94.5,
  r: 4.5
})), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 93.5,
  r: 4.5
})), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
  cx: 93.5,
  cy: 93.5,
  r: 4.5
})), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 93.5,
  r: 4.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 9.973a4.5 4.5 0 1 0 0-8.945v8.945ZM0 44.972a4.5 4.5 0 1 0 0-8.945v8.945ZM0 80.972a4.5 4.5 0 1 0 0-8.945v8.945ZM0 116.973a4.5 4.5 0 1 0 0-8.946v8.946Z",
  clipRule: "evenodd"
})));
export default SvgLoginDots;